import styled from '@emotion/styled';
import { MessageWrapper as LoadingMessageWrapper } from './OneDriveLoadingMessage';
import ErrorIcon from '../../../utils/icons/ErrorIcon';
import { FormattedMessage } from 'react-intl';

const MessageWrapper = styled(LoadingMessageWrapper)(({ theme }) => ({
  color: theme.palette.text.primary,
  '.MuiSvgIcon-root': {
    marginRight: 12,
  },
}));

const OneDriveErrorMessage = () => (
  <MessageWrapper>
    <ErrorIcon />
    <p>
      <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.messages.connection_error" />
    </p>
  </MessageWrapper>
);

export default OneDriveErrorMessage;
